// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"74":"664aa0ad","213":"448ae3c2","455":"47f9f60d"}[chunkId] + ".chunk.js";
};